import { FC } from 'react';
import { Category } from '../../../pages/learn/articles';
import { Article } from '../../../pages/learn/articles/[slug]';
import AngleButton from '../../AngleButton';
import ArticleCard from '../ArticleCard';

interface Props {
  category: Category;
  articles: Array<Article>;
}

const RecommendedArticles: FC<Props> = ({ category, articles }) => {
  const buttonString = `View all ${category.title} articles`;
  return (
    <>
      <h2>Keep Learning</h2>
      <div className='mt-8 grid md:grid-cols-2 gap-8'>
        {articles.map(article => (
          <div key={article.slug} className='h-56'>
            <ArticleCard article={article} />
          </div>
        ))}
      </div>
      <div className='mt-10'>
        <AngleButton text={buttonString} link={`articles/${category.slug}`} />
      </div>
    </>
  );
};

export default RecommendedArticles;
